import { createSelector } from 'reselect';
import { findWhere } from 'underscore';

export const getResources = state => state.resources.data;
export const getOwnResources = state => state.resources.ownResources;

export function getResourcesArray(state) {
    return getResources(state); // map(getResources(state), item => item).reverse();
}

export function getOwneResourcesArray(state) {
    return getOwnResources(state); // map(getResources(state), item => item).reverse();
}

export function getResourceById(state, id) {
    return findWhere(getResources(state), { id: parseInt(id, 10) }); // getResources(state)[id];
}

export function getOwnResourceById(state, id) {
    return findWhere(getOwnResources(state), { id: parseInt(id, 10) }); // getResources(state)[id];
}

// =====================================
//  MEMOIZED SELECTORS
// -------------------------------------

export const makeGetResourceById = () => createSelector(
    getResourceById,
    resource => resource
);

export const makeGetOwnResourceById = () => createSelector(
    getOwnResourceById,
    resource => resource
);



/** WEBPACK FOOTER **
 ** ./src/core/resources/resourcesSelectors.js
 **/